"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFinalForm = require("react-final-form");
var _components = require("@folio/stripes/components");
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FormModal = _ref => {
  let {
    children,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {},
    modalProps: {
      footer,
      onClose,
      ...modalProps
    },
    onError,
    // Optional handler to run onSuccess for default handleSaveAndClear
    onSubmit,
    onSuccess,
    // Optional handler to run onSuccess for default handleSaveAndClear
    ...formProps
  } = _ref;
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Form, {
    onSubmit: onSubmit,
    ...formProps,
    children: _ref2 => {
      let {
        handleSubmit,
        form: {
          getState,
          restart
        }
      } = _ref2;
      const formState = getState();
      const handleClose = e => {
        onClose(e);
        restart();
      };

      // Handle asynchronous submit functions differently to synchronous ones
      const handleSaveAndClear = function () {
        try {
          const submitReturn = handleSubmit(...arguments);

          // Figure out if we're in an async or sync submit function
          if (typeof submitReturn === 'object' && typeof submitReturn.then === 'function') {
            // Async function
            return submitReturn.then(incomingParams => {
              restart();
              return incomingParams;
            }).then(incomingParams => {
              if (onSuccess && typeof onSuccess === 'function') {
                // Allow onSuccess to dictate what continues downstream
                return onSuccess(incomingParams);
              }
              return incomingParams;
            }).catch(incomingParams => {
              if (onError && typeof onError === 'function') {
                // Allow onError to dictate what continues downstream
                return onError(incomingParams);
              }
              return incomingParams;
            });
          } else if (onSuccess && typeof onSuccess === 'function') {
            // Sync function and we have an onSuccess handler

            // onSuccess dictates return
            const returnShape = onSuccess(submitReturn);
            restart();
            return returnShape;
          } else {
            // Sync function and we have no onSuccess handler

            restart();
            return submitReturn;
          }
        } catch (err) {
          // Sync function catch
          if (onError && typeof onError === 'function') {
            // Allow onError to dictate what continues downstream
            return onError(err);
          }
          return null;
        }
      };
      const renderFooter = () => {
        if (footer) {
          return footer({
            formState,
            handleSubmit: handleSaveAndClear,
            handleClose,
            handleSubmitNoRestart: handleSubmit,
            // DEPRECATED -- should use handleSubmitRaw
            handleSubmitRaw: handleSubmit
          });
        }
        const {
          invalid,
          pristine,
          submitting,
          validating
        } = formState;
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.ModalFooter, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
            buttonStyle: "primary",
            disabled: submitting || invalid || pristine || validating,
            marginBottom0: true,
            onClick: handleSaveAndClear,
            type: "submit",
            children: kintIntl.formatKintMessage({
              id: 'saveAndClose',
              overrideValue: labelOverrides.saveAndClose
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
            marginBottom0: true,
            onClick: handleClose,
            children: kintIntl.formatKintMessage({
              id: 'cancel',
              overrideValue: labelOverrides.cancel
            })
          })]
        });
      };
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Modal, {
        enforceFocus: false,
        footer: renderFooter(),
        onClose: handleClose,
        ...modalProps,
        children: children
      });
    }
  });
};
FormModal.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.func]),
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  labelOverrides: _propTypes.default.object,
  modalProps: _propTypes.default.shape({
    footer: _propTypes.default.func,
    onClose: _propTypes.default.func
  }),
  onError: _propTypes.default.func,
  onSubmit: _propTypes.default.func,
  onSuccess: _propTypes.default.func
};
var _default = exports.default = FormModal;